import React, { Suspense } from "react";
import "./Settings.css";
import User_Profile from "../user_profile/User_Profile";
import { Navigate, Route, Routes } from "react-router-dom";
import Personalization from "./settings_route_components/personalization/Personalization";
import Select_Language from "./settings_route_components/select_language/Select_Language";
import Notification_Settings from "./settings_route_components/notification_settings/Notification_Settings";
import Privacy_Policy from "./settings_route_components/privacy_policy/Privacy_Policy";
import Terms_Conditions from "./settings_route_components/terms_conditions/Terms_Conditions";
import Donation_Cancellation from "./settings_route_components/donation_cancellation/Donation_Cancellation";
import Shipping_Delivery_Policy from "./settings_route_components/shipping_delivery_policy/Shipping_Delivery_Policy";

const Settings = () => {

  return (
    <section className="Settings">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-4 col-md-12 order-lg-1 order-2">
            <User_Profile showClose/>
          </div>
          <div className="col-lg-8 order-lg-2 order-1">
            <div className="setting_layout">
              <Routes>
                <Route path="/menu" element={<Personalization />} />
                <Route path="/select-language" element={<Select_Language />} />
                <Route path="/notification-settings" element={<Notification_Settings />} />
                
                <Route path="/privacy-policy" element={<Privacy_Policy />} />
                <Route path="/terms-conditions" element={<Terms_Conditions />} />
                <Route path="/donation-cancellation" element={<Donation_Cancellation />} />
                <Route path="/shipping-delivery-policy" element={<Shipping_Delivery_Policy />} />
              </Routes>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Settings;
